export default __webpack_public_path__ + "static/media/add-icon.feccad5f.svg";